//@flow
import { connect } from 'react-redux';
import SuspendSwapTerminateSuccess from './SuspendSwapTerminateSuccess.container';
import { customerEmailSelector } from '../../modules/Customer/selectors';
import { goToSimActivation } from '../../modules/Navigation/actions';
import I18n from '../../lib/i18n';
import theme from '../../theme-config';

import type { DispatchProps, StateProps } from '../../components/SuccessPage/SuccessPage';
import type { StateType } from '../../modules/reducers';

const mapStateToProps = (state: StateType): StateProps => ({
  successImage: theme.successPhoneImage,
  successTitle: I18n.t('Dashboard.Unsuspension.successTitle', {
    customerEmail: customerEmailSelector(state),
  }),
  confirmButtonText: I18n.t('Dashboard.Unsuspension.confirmButton'),
  secondaryButtonText: I18n.t('Dashboard.Unsuspension.secondaryButton'),
});

const mapDispatchToProps: DispatchProps = {
  onSecondaryButtonPress: goToSimActivation,
};

export default connect(mapStateToProps, mapDispatchToProps)(SuspendSwapTerminateSuccess);
